import {
  QUIZ_PAGE_UPDATE_FORM_FIELD,
  QUIZ_PAGE_TRIGGER_REQUEST,
  QUIZ_PAGE_UPDATE_REQUEST_STATE,
  QUIZ_PAGE_RESET_STATE,
} from '../constants/actionTypes';

import {
  REQUEST_UNSTARTED,
  REQUEST_SUCCESS,
  REQUEST_FETCHING,
  REQUEST_ERROR,
} from '../constants/requestStates';

export const resetQuizPage = () => {
  return {
    type: QUIZ_PAGE_RESET_STATE
  }
};

export const quizPageTriggerRequest = (key) => {
  return {
    type: QUIZ_PAGE_TRIGGER_REQUEST + key,
    payload: {
      key,
    }
  }
};

export const quizPageUpdateRequestState = (key, state, result=undefined) => {
  let payload = {
    state,
  };
  if (!!(result)) {
    if (state === REQUEST_SUCCESS || state === REQUEST_FETCHING || state === REQUEST_UNSTARTED) {
      payload.result = result
    }
    if (state === REQUEST_ERROR) {
      payload.error = result;
    }
  }
  return {
    type: QUIZ_PAGE_UPDATE_REQUEST_STATE,
    key,
    payload,
  }
}

export const quizPageUpdateFormField = (key, value) => {
  return {
    type: QUIZ_PAGE_UPDATE_FORM_FIELD,
    payload: {[key]: value}
  }
};
